import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from "./redux/store";
import { Provider } from 'react-redux';
import {AgamRgpd} from '@agam_marseille/package_composants_generiques'





ReactDOM.render(
  <React.StrictMode>
    <AgamRgpd url={"cinemas"}> 
      <Provider store={store}>
      <App />
      </Provider>
    </AgamRgpd> 
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

